import firstFn from 'lodash/first'
import values from 'lodash/values'

import Muncher from '.'

export default class NumericMetric extends Muncher {
  /**
   * call - This method returns the data structure to print a numeric metric line chart.
   *
   * @method
   */
  call() {
    const first = firstFn(this.data)
    const initialData = this.query.fields.primaryField

    if (!first) return

    const initialDataValue = first[initialData] ?? 0

    const value = initialData ? initialDataValue : values(first)[0]

    return this.formatter(this.query.aggregation)(value)
  }
}
